interface Props {
  [key: string]: any
}

function ChevronBoldRightIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 8 13" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M2 11L6 6.5L2 2"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="2.75"
      />
    </svg>
  )
}

export default ChevronBoldRightIcon
